import { careTypeFromId, idFromCareType, searchFormatter } from "./search-helper.js";

window.addEventListener("load", () => {
  set_search_form_action();
  initialize_google_maps();
  insert_datapoint();
  additional_features();
});

function insert_datapoint() {
  const datapoints = [
    [
      "What is the percentage of seniors 65 years old and over needing long term care service over time?",
      "At least 70% of people over the age of 65 will require some form of long term care services and support during their lives.",
      "2015 Medicare and You – National Medicare Handbook",
    ],
    [
      "How many licensed facilities are there addressing the need for Senior Care in the United States and their year over year growth rate?",
      "As of 2013, there are a total 58,000 facilities and 2,551,400 licensed beds dedicated to Senior Care in the United States with a growth rate of 1.9% a year.",
      "CDC Long Term Care Overview 2013",
    ],
    [
      "How many Americans reside in Senior Care facilities that require Long Term Care?",
      "Roughly 1 million Americans reside in Senior Care facilities. An estimated 12 million Americans needed Long Term Care in 2007.",
      "SBDC – J Ortiz 2009; Center for American Progress – Long Term Care Services 2015",
    ],
    [
      "What percentage of people 65 and over is predicted to compose the population of the United States?",
      "The U.S. Census Bureau predicts that people over the age of 65 will comprise about 20% of the U.S. population by 2060.",
      "2015 Medicare and You – National Medicare Handbook",
    ],
    [
      "What is the rate of population increase between the ages of 65 and 84 by 2010 and 2020?",
      "According to the U.S. Census Bureau, the number of individuals in the US between the ages of 65 and 84 will increase by 38.8% between 2010 and 2020, while the population over age 85 will increase by 18.7%.",
      "2015 Medicare and You – National Medicare Handbook",
    ],
    [
      "What a  re the fastest growing jobs in the Senior Care industry and its’ predicted growth?",
      "Direct-care workers - CNAs, Home Health Aides - are expected to be the largest occupational segment by 2020.",
      "2010 Bureau of Labor Statistics",
    ],
    [
      "How big is the number of caregiving households in the US for 50 and over persons and seniors?",
      "By the year 2007, the number of caregiving households in the U.S. for persons aged 50+ could reach 39 million.",
      "National Alliance for Caregiving and AARP 2009",
    ],
    [
      "How many workers or people are involved in taking care of the aged and disabled in the United States?",
      "65.7 million informal and family caregivers provide care to someone who is ill, disabled or aged in the U.S.",
      "National Alliance for Caregiving and AARP 2009",
    ],
    [
      "How many non-professional caregivers such as family members provide care to 65 and over seniors in the United States?",
      "5.8 to 7 million people (family, friends and neighbors) provide care to a person (65+) who needs assistance with everyday activities.",
      "Health and Human Services Report 1982, 1989, 1994",
    ],
    [
      "How many caregivers provide caregiving to people aged 18 years and older?",
      "52 million caregivers (or one out of every five households) are involved in caregiving to persons aged 18 or over.",
      "Coughlin, J. (2010) Estimating the Impact of Caregiving and Employment on Well-Being: Vol 2: Issue 1.",
    ],
    [
      "What is the average lifetime out-of-pocket expense for older people and seniors dedicated to long term costs before they die?",
      "Nearly a fifth of older people will incur more than $25,000 in lifetime out-of-pocket long-term costs before they die.",
      "The Retirement Project (2007) Meeting the Long-Term Needs of the Baby boomers",
    ],
    [
      "How big will long-term care services grow as an industry and what factors influence this growth?",
      "By 2050, the number of individuals using paid long-term care services in any setting (e.g., at home, residential care such as assisted living, or skilled nursing facilities) will likely double from the 13 million using services in 2000, to 27 million people. This estimate is influenced by growth in the population of older people in need of care.",
      "USDOHHS and USDOL The future supply of long-term care workers in relation to the aging baby boom generation",
    ],
    [
      "What is the percentage of the U.S. population of adult children in their 40s and 50s, are taking care as well as financially supporting their children and their adult parents?",
      "Nearly half (47%) of adults in their 40s and 50s have a parent age 65 or older and are either raising a young child or financially supporting a grown child (age 18 or older).  And about one-in-seven middle-aged adults (15%) is providing financial support to both an aging parent and a child.",
      "Pew Center Research – The Sandwich Generation – Sample Size group n=844, n=1,185 (2013)",
    ],
    [
      "Are seniors or people in general preferring home care services versus nursing or convalescent homes?",
      "Studies have shown that community-based or delivery of home care services is a cost effective alternative to nursing homes. Care in the home, residential care homes or community, not nursing home care, is what most Americans would prefer.",
      "Family Caregiver Alliance National Center on Caregiving – Long Term Care Stats 2015",
    ],
    [
      "What is the percentage of seniors in the United States, who are preferring to stay at home as they grow older and age?",
      "More people are choosing to remain in their homes as they age. Various studies on aging, including a 2009 AARP study, have found that up to 89% of seniors want to live in their own homes as long as possible. The senior population has become the fastest growing segment in the United States; thus, the need for home care businesses will continue to increase.",
      "Genworth Cost of Care Survey 2015",
    ],
    [
      "How much is the annual cost of caregiving?",
      "From a Sept 2014 Caring Cost Index, 46% of caregivers surveyed spent more than $5K annually in caregiving cost, around 7% spent $50K or more each year.",
      "Caring Cost Index 9/2014",
    ],
  ];
  let results = Array.from(document.querySelectorAll(".search-result"));
  let insertNearbyAfter = results.length < 10 ? results.length : 10;
  let insertDataPointAfter = results.length < 20 ? results.length : 20;

  //Insert datapoint
  let dataPointNum = Math.floor(Math.random() * datapoints.length);
  let randomDataPoint = datapoints[dataPointNum];
  let dataPoint = document.createElement("div");
  dataPoint.setAttribute("class", "senior-care-fact");

  let dataPointInfo = document.createElement("div");
  dataPointInfo.setAttribute("class", "col-6 fact-container");

  let dataPointImg = document.createElement("div");
  dataPointImg.setAttribute("class", "col-5 fact-image");

  let img = document.createElement("img");
  img.src = "/app/themes/shn/assets/images/srp-datapoints/Point" + dataPointNum + ".png";
  img.setAttribute("width", "300");
  img.setAttribute("height", "200");

  dataPointImg.appendChild(img);

  let dataTitle = document.createElement("p");
  dataTitle.setAttribute("class", "fact-title");
  dataTitle.textContent = randomDataPoint[0];

  let dataFact = document.createElement("span");
  dataFact.setAttribute("class", "fact-data");
  dataFact.textContent = randomDataPoint[1] + " ";

  let dataSource = document.createElement("span");
  dataSource.setAttribute("class", "fact-source");
  dataSource.textContent = randomDataPoint[2];

  dataPointInfo.appendChild(dataTitle);
  dataPointInfo.appendChild(dataFact);
  dataPointInfo.appendChild(dataSource);

  dataPoint.appendChild(dataPointImg);
  dataPoint.appendChild(dataPointInfo);

  jQuery(results[insertDataPointAfter - 1].after(dataPoint));

  //Insert nearby
  let nearbyBlock = document.getElementById("nearby-listings");
  if (nearbyBlock !== null) {
    jQuery(results[insertNearbyAfter - 1].after(nearbyBlock));
  }

  jQuery(".nearby-listings").slick({
    arrows: true,
    speed: 300,
    infinite: true,
    centerMode: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: '<div class="slick-next arrows"></div>',
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  jQuery(".slick-prev").hide();
}

function set_search_form_action() {
  let form = document.getElementById("srp-search-form");
  let errorContainer = document.querySelector(".error-container");
  let advancedButton = document.querySelector(".search-filter");
  let advancedCheckboxes = Array.from(document.querySelectorAll(".srp-ct-filter"));
  let advancedContainer = document.querySelector(".filters-container");
  if (form != null) {
    form.addEventListener("submit", function(e) {
      e.preventDefault();
      let searchInput = document.getElementById("srp-search-location");
      let ctyp = document.getElementsByName("ctyp");
      let searchLocation = "";
      let url_append = "";
      let trackingCt = [];
      if (searchInput.value != "") {
        errorContainer.style.display = "none";
        searchLocation = searchFormatter(searchInput.value);
        let checked = Array.prototype.slice.call(ctyp).filter(function(e) {
          return e.checked;
        });
        if (checked.length == 1) {
          let care_type = careTypeFromId(checked[0].value);
          url_append = "/" + care_type + "_type";
          trackingCt.push(care_type);
        } else if (checked.length > 1) {
          let values = checked.map(function(check) {
            return check.value;
          });
          values.forEach(ct => {
            trackingCt.push(idFromCareType(ct));
          });
          url_append = "?ctyp=" + values.join("&ctyp=");
        }
        if (searchLocation == "") {
          url_append = "";
        }
        window.dataLayer.push({
          search_input: searchLocation,
          search_filter: trackingCt.join(", "),
        });
        window.location = "/seniorliving-search/" + searchLocation + url_append;
      } else {
        e.preventDefault();
        errorContainer.style.display = "block";
        advancedContainer.style.display = "none";
      }
    });
  }

  advancedButton.addEventListener("click", () => {
    if (advancedContainer.style.display != "block") {
      advancedContainer.style.display = "block";
      errorContainer.style.display = "none";
    } else {
      advancedContainer.style.display = "none";
    }
  });
  advancedCheckboxes.forEach(checkbox => {
    checkbox.addEventListener("click", () => {
      checkbox.classList.toggle("checked");
    });
  });
}

//Google maps
function initialize_google_maps() {
  let locations = document.querySelectorAll(".coords");
  let lat = parseFloat(locations[0].firstElementChild.content);
  let long = parseFloat(locations[0].lastElementChild.content);
  let property = { lat: lat, lng: long };
  let mapOptions = {
    zoom: 8,
    center: property,
    disableDefaultUI: true,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_TOP,
    },
    fullscreenControl: false,
  };
  let bounds = new google.maps.LatLngBounds();
  let infowindow = new google.maps.InfoWindow();
  let map = new google.maps.Map(document.querySelector(".map"), mapOptions);
  let icon = "/app/themes/shn/assets/images/mappingnew.png";
  let activeIcon = "/app/themes/shn/assets/images/mappin-active.png";

  locations.forEach(function(location) {
    let propertyName = location.parentElement.firstElementChild.firstElementChild.innerText;
    let propertyImage =
      location.parentElement.parentElement.firstElementChild.firstElementChild.getAttribute("data-src") != null
        ? location.parentElement.parentElement.firstElementChild.firstElementChild.getAttribute("data-src")
        : "";
    let propertyUrl = location.parentElement.children[5].href;
    let marker;
    marker = new google.maps.Marker({
      position: new google.maps.LatLng(
        parseFloat(location.firstElementChild.content),
        parseFloat(location.lastElementChild.content)
      ),
      icon: icon,
      map: map,
    });
    bounds.extend(marker.position);
    let content = "";
    content += "<a href='" + propertyUrl + "'>";
    if (propertyImage != "") {
      content += "<div><img class='map-img'src=" + propertyImage + "></div>";
    }
    content += "<div class='map-title'>" + propertyName + "</div></a>";

    marker.addListener("click", function() {
      infowindow.setContent(content);
      infowindow.open(map, marker);
    });
    //Highlight map icons on div hover
    location.parentElement.parentElement.addEventListener("mouseover", function() {
      marker.setIcon(activeIcon);
    });
    location.parentElement.parentElement.addEventListener("mouseout", function() {
      marker.setIcon(icon);
    });

    //Highlight icons on icon hover
    marker.addListener("mouseover", function() {
      marker.setIcon(activeIcon);
    });
    marker.addListener("mouseout", function() {
      marker.setIcon(icon);
    });
  });

  //Add class to map markers for GTM
  google.maps.event.addListenerOnce(map, "tilesloaded", function() {
    Array.from(document.querySelectorAll(".map-container img")).forEach(function(marker) {
      marker.classList.add("geo-map-icon");
    });
  });
  map.fitBounds(bounds);
}

function additional_features() {
  //check caretypes
  if (window.location.href.includes("_type") || window.location.href.includes("ctyp")) {
    let advancedButton = document.querySelector(".search-filter");
    if (window.location.href.includes("ctyp")) {
      let caretypes = location.search.slice(6).split("&ctyp=");
      advancedButton.innerHTML += " (" + caretypes.length + ")";
      caretypes.forEach(function(id) {
        Array.from(document.getElementsByClassName("srp-ct-filter")).forEach(function(ct) {
          if (ct.getAttribute("data-search") == careTypeFromId(id)) {
            ct.checked = true;
          }
        });
      });
    } else {
      advancedButton.innerHTML += " (1)";
      let caretype = window.location.href.substring(window.location.href.lastIndexOf("/") + 1).replace("_type", "");
      Array.from(document.getElementsByClassName("srp-ct-filter")).forEach(function(ct) {
        if (ct.getAttribute("data-search") == caretype) {
          ct.checked = true;
        }
      });
    }
  }

  //Call info in provider listings
  jQuery(document).scroll(function() {
    jQuery(".need-help").each(function() {
      let y = jQuery(document).scrollTop();
      let t = jQuery(this)
        .parent()
        .offset().top;
      if (y > t) {
        jQuery(this).fadeIn();
      } else {
        jQuery(this).fadeOut();
      }
    });
  });

  //toggle for maps/list when tablet/mobile
  document.querySelector(".switch-container").addEventListener("click", () => {
    let gmap = document.querySelector(".map-container");
    let list = document.querySelector("#property-listings");
    let geoToc = document.querySelector(".geo-toc");
    let geoTopContent = document.querySelector(".geo-top-content");
    let listContainer = document.querySelector(".search-results-container");
    let listimg = document.querySelector(".switch-img-list");
    let mapimg = document.querySelector(".switch-img-map");
    if (gmap.style.display == "" || gmap.style.display === "none") {
      gmap.style.display = "block";
      if (geoToc) geoToc.style.display = "none";
      if (geoTopContent) geoTopContent.style.display = "none";
      list.style.display = "none";
      listContainer.style.height = "100vh";
      listimg.style.display = "block";
      mapimg.style.display = "none";
      window.scrollTo(0, 0);
      document.scrollingElement.style.overflow = "hidden";
      initialize_google_maps();
    } else {
      gmap.style.display = "none";
      if (geoToc) geoToc.style.display = "block";
      if (geoTopContent) geoTopContent.style.display = "inline-block";
      list.style.display = "block";
      listimg.style.display = "none";
      mapimg.style.display = "block";
      listContainer.style.height = "auto";
      document.scrollingElement.style.overflow = "auto";
    }
  });
}
